import { ShieldCheck, Clock, Users, Lock } from "lucide-react";

const STATS = [
  { k: "50", v: "U.S. states served" },
  { k: "24 hrs", v: "Average plan delivery" },
];

const REASONS = [
  {
    icon: ShieldCheck,
    t: "Licensed & bonded advocates",
    d: "Every advocate is trained in state-specific foreclosure law and background-checked.",
  },
  {
    icon: Lock,
    t: "Absolute confidentiality",
    d: "Your situation stays between you and us. No neighbors, no lenders fishing, no data sales.",
  },
  {
    icon: Clock,
    t: "Speed when it matters most",
    d: "We triage urgent auctions the same day and never let a homeowner miss a statutory deadline.",
  },
  {
    icon: Users,
    t: "Family-first, not fee-first",
    d: "If the right answer is to stay in your home and we can't earn from it, we still help you get there.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-section"
      className="py-20 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="mb-4">
              <span className="gold-rule" />
              <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
                Why Clear Path Home Relief Services
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight mb-6">
              Built by homeowners, <em className="font-medium text-[#C5A059] not-italic">for homeowners.</em>
            </h2>
            <p className="text-[#64748B] leading-relaxed mb-8">
              Our founders went through foreclosure themselves — and saw how predatory,
              confusing, and lonely the process felt. We built Clear Path Home Relief Services to
              be what we wished we'd had: clear, honest, and on your side from day one.
            </p>

            <div className="relative rounded-lg overflow-hidden border border-[#E5E3DB]">
              <img
                src="https://images.unsplash.com/photo-1758518730384-be3d205838e8"
                alt="Advocate meeting homeowners"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <div className="grid grid-cols-2 gap-6">
              {STATS.map((s, i) => (
                <div
                  key={i}
                  data-testid={`why-stat-${i}`}
                  className="rounded-lg bg-[#0B1B3D] text-white p-6 lg:p-7"
                >
                  <div className="font-display text-3xl lg:text-4xl text-[#C5A059] leading-none mb-2">
                    {s.k}
                  </div>
                  <div className="text-xs uppercase tracking-[0.18em] text-white/70">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {REASONS.map((r, i) => (
                <div
                  key={i}
                  data-testid={`why-reason-${i}`}
                  className="rounded-lg border border-[#E5E3DB] bg-white p-5"
                >
                  <div className="h-9 w-9 rounded-md bg-[#2C5545]/10 flex items-center justify-center mb-3">
                    <r.icon className="h-4 w-4 text-[#2C5545]" />
                  </div>
                  <div className="font-medium text-[#0B1B3D] mb-1">{r.t}</div>
                  <div className="text-sm text-[#64748B] leading-relaxed">{r.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
